export const API_ENDPOINT = {
  slugImages: "https://emisortotem.totalpack.cl/images",
  endpoint: "https://apiturno.totalpack.cl/Turno/v1",
  version: "2.2.6",
  tLlamado: 60,
  tEspera: 5,
  apiUrl: "https://apiturno.totalpack.cl/v1/turno-hub",
  api_auxiliar: {
    url: "https://adminv40.totalpack.cl/auxiliar/api/v1",
    apiKey: "RhY7kFE9skCCUBVLvXnvdQ==",
  },
  apiBox: {
    url: "https://apillamadosbox.totalpack.cl",
    apiKey: "Q3VzdG9tZXJzVFRQ"
  },
  clients: {
    hide_phone: ['ttp_viajesfalabella', 'ttp_rsalud', 'ttp_bancobice', 'ttp_rsaludtest', 'ttp_clinicaferrer']
  }
};
